import _ from 'lodash'
import type {AspectRatioSize, AspectRatioSizeType} from '@wix/document-services-types'
import type {CssValue} from '../../constants'
import {deserializeFunction, serializeFunction} from '../utils/function'

const ASPECT_RATIO_TYPE: AspectRatioSizeType = 'aspectRatio'
const ASPECT_RATIO_FUNCTION_NAME: string = 'aspect-ratio'

const serialize = (val: any): CssValue | undefined => {
    if (!_.isPlainObject(val)) {
        return undefined
    }

    const {type, value} = val

    if (type !== ASPECT_RATIO_TYPE || !_.isNumber(value)) {
        return undefined
    }

    return serializeFunction({name: ASPECT_RATIO_FUNCTION_NAME, args: [`${value}`]})
}

const deserialize = (rule: CssValue): AspectRatioSize | undefined => {
    const func = deserializeFunction(rule)
    if (!func) {
        return undefined
    }

    const {name, args} = func

    if (name !== ASPECT_RATIO_FUNCTION_NAME || args.length !== 1) {
        return undefined
    }

    const value = _.toNumber(args[0])
    if (_.isNaN(value)) {
        return undefined
    }

    return {
        type: ASPECT_RATIO_TYPE,
        value: +value
    }
}

export default {
    serialize,
    deserialize
}
